import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';
import { PaginationObject} from '../pagination-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { ErrorDetails} from '../errors/errordetails';
import { SampleSearchRecordObject } from '../../../shared/services/submission-history-object';
import { SubmissionSearchUserInfoObject} from '../search-object';
import { ModalService } from '../../../shared/services/modal.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'sample-search-table',
    templateUrl: './sample-search-table.component.html',
    styleUrls: [ './sample-search-table.component.scss' ]
})
export class SampleSearchTableComponent implements OnInit, OnDestroy {
    @ViewChild('errorDialog')
    private modalSampleErrors: ModalComponent;

    activeFileRecordList: SampleSearchRecordObject[] = new Array<SampleSearchRecordObject>();
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();
    errorModalTitle: string;
    modalSampleId: string;
    errorDetails: ErrorDetails[] = new Array<ErrorDetails>();
    samplePagination: PaginationObject = new PaginationObject();

    private userInfoSubscription: Subscription;
    private sampleSearchTableSubscription: Subscription;
    private paginationSubscription: Subscription;

    @ViewChild('sampleSource')
    private modalSubmissionSource: ModalComponent;

    sourceModalTitle: string;
    sourceModalContent: string;

    private      errorDetailsSubscription: Subscription;

    constructor(private submissionHistoryService: SubmissionHistoryService,
                private modalService: ModalService, private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer) {
      this.matIconRegistry.addSvgIcon(
        `fhir`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`images/fhir_trademark_transparent.svg`)
      );
    }


    ngOnInit() {
        this.sampleSearchTableSubscription = this.submissionHistoryService.currentSampleSearchTable
            .subscribe(message => this.activeFileRecordList = message);
        this.paginationSubscription = this.submissionHistoryService.currentSamplePagination
            .subscribe(message => this.samplePagination = message);
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo
            .subscribe(message => this.userInfo = message);
        this.errorDetailsSubscription = this.submissionHistoryService.currentSampleErrorDetails.subscribe(errors => {
            this.errorDetails = errors;
            if (errors !== null) {
                this.errorModalTitle = 'Error Message(s) for selected sample';
            } else {
                this.errorModalTitle = '';
            }
        });
    }


    ngOnDestroy() {
        this.sampleSearchTableSubscription.unsubscribe();
        this.errorDetailsSubscription.unsubscribe();
        this.userInfoSubscription.unsubscribe();
        this.paginationSubscription.unsubscribe();
    }


    review(checked: boolean, docidGuid: any, sampleId: any) {
        this.submissionHistoryService.sampleSearchReview(checked, docidGuid, sampleId).then(result =>  {
        if (result) {
        }});
    }


    public displaySubmissionSourceDialog(uuid: string, hmlId: string, uploaderFileName: string,
                                         submissionStatus: string, testType?: string): void {
        this.modalService.openSubmissionSourceDialog(uuid, hmlId, uploaderFileName, submissionStatus, testType);
    }


    public displaySourceDialog(uuid: string, sampleId: string, testType?: string): void {
        // Step 1: Temporarily clear the title and content areas of the dialog so that a previous
        // sample's contents don't get displayed.
        // TODO: In a future story, replace this with a loading spinner.
        this.sourceModalTitle = 'Loading sample source...';
        this.sourceModalContent = '\n\n\n\n\n\n\n';

        // DSA Antibody sample source is JSON, so it should be displayed pretty-printed
        // rather than as a single unformatted line.
        const isDsaAntibody = testType === 'DSA Antibody';

        // Step 2: Load the actual content
        let title = isDsaAntibody
            ? 'Antibody Submission ' + sampleId
            : 'HML Preview Sample ID ' + sampleId;
        this.submissionHistoryService
            .getSampleSource(uuid, sampleId)
            .then(response =>  {
                if(response) {
                    this.sourceModalTitle = title;
                    this.sourceModalContent = isDsaAntibody
                        ? JSON.stringify(JSON.parse(response), null, 2)
                        : response;
                }
            });
        this.modalSubmissionSource.open();
    }


    public displaySampErrorDialog(uuid: string, sampleId: string): void {
        this.modalSampleId = sampleId;
        this.errorModalTitle = 'Error Message(s) for sample id ' + sampleId;
        this.errorDetails = [];

        this.submissionHistoryService.getSampleErrors(uuid, sampleId); // Subscribed to Observable ErrorDetails in service
        this.modalSampleErrors.open();
    }

    extract() {
        this.submissionHistoryService.getSamplesSearchExportContent();
    }
}

